import gql from 'graphql-tag';

export async function get_gestiones(vue) {
  let sql = gql`
    query {
      getGestiones {
        gestion
        apertura
        cierre
      }
    }
  `;
  let res = await vue.$apollo
    .query({ query: sql })
    .then(({ data }) => (data ? data.getGestiones : []))
    .catch((error) => error);
  //window.console.log('ges::', res);
  return res;
}

export async function listarprogramasgraphql(vue) {
  vue.loadingprograms = true;
  vue.loadingmodulos = true;
  vue.programas = [];
  let idsede = vue.$store.state.CARGO.sede.id;
  var sql = gql`query{ getProgramas(cursor:1000000,estado:true,idsede:${idsede}, gestion:${vue.gestion}){ id,fase,version,grupo,estado,fecha_inicio,fecha_fin,codigo,nombre_compuesto,plataforma_id} }`;
  let res = await vue.$apollo
    .query({ query: sql, variables: { cursor: vue.cursor } })
    .then(({ data }) => {
      data.getProgramas.map((x) => {
        x.text = x.nombre_compuesto;
      });
      return data.getProgramas;
    })
    .catch(() => {
      vue.loadingprograms = false;
      vue.loadingmodulos = false;
      return [];
    });
  return res;
}
